import { cn } from '@/app/utils/cn';

export function NoResults({
    text = 'No posts found for the selected filter(s).',
    className = '',
    as = 'div'
}) {
    const Component = as;
    return <Component className={cn('text-center text-gray-500', className)}>{text}</Component>;
}

export default NoResults;
